import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import { invalidateCompanySkillQueries } from '../../manage-siesta-skills/hooks/invalidateCompanySkillQueries';
import type { SiestaSkill } from '../../manage-siesta-skills/types';

export default function useAddSkillLibraryEntry() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (entryId: string) => {
      const { data } = await api.post<SiestaSkill>(`/skill-library/${entryId}/add`);
      return data;
    },
    onSuccess: () => invalidateCompanySkillQueries(queryClient),
  });
}
